import React, { useEffect, useState } from 'react'
import { Button, Col, Container, Form, Image, Row } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { ACCESS_TOKEN } from '../common/local-storage/Contants'
import ManagePackageService from '../services/ManagePackageService'
import Loading from '../components/loading/Loading';
import SweetAlert2 from 'react-sweetalert2';
import { isAccessTokenExpire } from '../common/utils/validate'

import { withSwal } from 'react-sweetalert2';


function Login() {
    const navigate = useNavigate()

    const [isLoading, setIsLoading] = useState(false)
    const [swalProps, setSwalProps] = useState({});

    const [dataInput, setDataInput] = useState({
        username: '',
        password: ''
    })

    useEffect(() => {

        let token = localStorage.getItem(ACCESS_TOKEN)

        if (token !== null && !isAccessTokenExpire(token)) {
            navigate('/')
        }
    }, [])


    return (
        <Container className='font-link'>
            <Row className="mt-5">
                <Col lg={5} md={6} sm={12} className="p-5 m-auto shadow-sm rounded-lg" >
                    <Row className="justify-content-md-center">
                        <Col xs={12} sm={4} md={4}>
                            <Image width={60} src='https://management.fahfon.info/images/icon/logo.png' />
                        </Col>
                    </Row>

                    <Form className='mt-4'>
                        <Form.Group controlId="formBasicEmail">
                            <Form.Control type="text" placeholder="Username"
                                onChange={(e) => {
                                    setDataInput(prevState => ({
                                        ...prevState, username: e.target.value
                                    }))

                                }} />
                        </Form.Group>

                        <Form.Group className='mt-3' controlId="formBasicPassword">
                            <Form.Control type="password" placeholder="Password"
                                onChange={(e) => {
                                    setDataInput(prevState => ({
                                        ...prevState, password: e.target.value
                                    }))

                                }} />
                        </Form.Group>

                        <Button className="bt-login mt-4" variant="primary btn-block"
                            onClick={() => {


                                onSubmit()
                            }}
                        >
                            Login
                        </Button>
                    </Form>
                </Col>
            </Row>

            <Loading isShow={isLoading} />


            <SweetAlert2 {...swalProps}

                didClose={() => {
                    setSwalProps({
                        show: false,
                        icon: 'info',
                        html: 'กรุณากรอกข้อมูลให้ถูกต้อง',
                        showConfirmButton: true,
                        confirmButtonColor: '#0d6efd',
                        confirmButtonText: 'OK',
                    });
                }}

                onConfirm={result => {
                    setSwalProps({
                        show: false,
                        icon: 'info',
                        html: 'กรุณากรอกข้อมูลให้ถูกต้อง',
                        showConfirmButton: true,
                        confirmButtonColor: '#0d6efd',
                        confirmButtonText: 'OK',
                    });
                }}


            />

        </Container>
    )


    function onSubmit() {

        if (dataInput.username === '') {
            setSwalProps({
                show: true,
                icon: 'info',
                html: 'กรุณาระบุชื่อผู้ใช้งาน',
                showConfirmButton: true,
                confirmButtonColor: '#0d6efd',
                confirmButtonText: 'OK',
            });
        }
        else if (dataInput.password === '') {
            setSwalProps({
                show: true,
                icon: 'info',
                html: 'กรุณาระบุรหัสผ่าน',
                showConfirmButton: true,
                confirmButtonColor: '#0d6efd',
                confirmButtonText: 'OK',
            });
        }
        else {
            signIn()
        }
    }

    async function signIn() {

        setIsLoading(true)

        // let body = {
        //     Username: "manageuser-admin",
        //     Password: "admin"
        // }

        let body = {
            Username: dataInput.username,
            Password: dataInput.password
        }

        ManagePackageService.login(body).then(result => {
            setIsLoading(false)
            if (result.status === 200) {

                localStorage.setItem(ACCESS_TOKEN, result.data.token)

                navigate('/')
            }

        }).catch(err => {
            setIsLoading(false)
            if (err.status === 401) {
                setSwalProps({
                    show: true,
                    icon: 'info',
                    html: 'ผู้ใช้งานหรือรหัสผิดพลาด',
                    showConfirmButton: true,
                    confirmButtonColor: '#0d6efd',
                    confirmButtonText: 'OK',
                });

            }
        })




    }
}

export default Login